export * from './fare-selectors-boolean.interface';
